var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip, Link, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { ReactComponent as MoreIconSvg } from '../../../assets/images/dots-vertical.svg';
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import CardView from "../../proprietaryWarranty/pages/proprietaryCardView";
import ViewInvoice from "../component/viewInvoice";
import { jciFilterPagingAPI } from "../services/apiCall";
import { JobCardInvoicesKeys } from "../services/entity";
export var InvoicedTab = function (props) {
    var value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'Invoice' : _a, disabled = props.disabled;
    var dispatch = useAppDispatch();
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var crud = useAppSelector(function (state) { return state.crud; });
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var pagingColumns = [{
            field: 'TransactionDocumentNo',
            headerName: 'Job card no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TransactionDocumentNo ? "".concat(row === null || row === void 0 ? void 0 : row.TransactionDocumentNo) : '-'; },
            minWidth: 175
        }, {
            field: 'InvoiceNumber',
            headerName: 'Job card invoice no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceNumber ? "".concat(row === null || row === void 0 ? void 0 : row.InvoiceNumber) : '-'; },
            minWidth: 250,
            renderCell: function (params) {
                var _params$row;
                return /*#__PURE__*/ React.createElement(Link, {
                    underline: "none",
                    component: 'button',
                    variant: "body1",
                    onClick: function () {
                        dispatch(showSurface({
                            type: 'Drawer',
                            Component: ViewInvoice,
                            containerProps: {
                                PaperProps: {
                                    sx: {
                                        width: '80%'
                                    }
                                },
                                anchor: 'right'
                            },
                            componentProps: {
                                data: params === null || params === void 0 ? void 0 : params.row
                            }
                        }));
                    }
                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.InvoiceNumber);
            }
        }, {
            field: 'InvoiceDate',
            headerName: 'Invoice date',
            valueFormatter: function (val, row) {
                var _row$InvoiceDate;
                return row !== null && row !== void 0 && row.InvoiceDate ? dayjs((_row$InvoiceDate = row === null || row === void 0 ? void 0 : row.InvoiceDate) !== null && _row$InvoiceDate !== void 0 ? _row$InvoiceDate : '').format('DD MMM, YYYY') : '-';
            },
            minWidth: 175
        }, {
            field: 'PostingType',
            headerName: 'Posting type',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PostingType ? "".concat(row === null || row === void 0 ? void 0 : row.PostingType) : '-'; },
            minWidth: 175
        }, {
            field: 'RegistrationNo',
            headerName: 'Registration no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RegistrationNo ? "".concat(row === null || row === void 0 ? void 0 : row.RegistrationNo) : '-'; },
            minWidth: 175
        }, {
            field: 'CustomerName',
            headerName: 'Customer name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CustomerName ? "".concat(row === null || row === void 0 ? void 0 : row.CustomerName) : '-'; },
            minWidth: 175
        }, {
            field: 'MobileNo',
            headerName: 'Mobile no.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.MobileNumber ? "".concat(row === null || row === void 0 ? void 0 : row.MobileNumber) : '-'; },
            minWidth: 175
        }, {
            field: 'InvoiceAmount',
            headerName: 'Invoice amount',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.InvoiceAmount ? "".concat(row === null || row === void 0 ? void 0 : row.InvoiceAmount.toFixed(2)) : '-'; },
            minWidth: 175
        }, {
            field: 'CurrentOutstanding',
            headerName: 'Out standing amount',
            valueFormatter: function (val, row) { return row === null || row === void 0 ? void 0 : row.CurrentOutstanding.toFixed(2); },
            minWidth: 175
        }, {
            field: 'PaymentStatus',
            headerName: 'Payment status',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.PaymentStatus ? "".concat(row === null || row === void 0 ? void 0 : row.PaymentStatus) : '-'; },
            minWidth: 175
        }, {
            field: 'ServiceAdvisorName',
            headerName: 'Service advisor',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ServiceAdvisorName ? "".concat(row === null || row === void 0 ? void 0 : row.ServiceAdvisorName) : '-'; },
            minWidth: 175
        }, {
            field: 'JobcardStatus',
            headerName: 'Status',
            renderCell: function (params) {
                var _params$row$JobcardSt, _params$row2;
                return /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$JobcardSt = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.JobcardStatus) !== null && _params$row$JobcardSt !== void 0 ? _params$row$JobcardSt : '-',
                    size: "small",
                    variant: "filled",
                    color: "primary",
                    sx: {
                        borderRadius: 6,
                        px: 1,
                        fontWeight: 'medium',
                        fontSize: 12
                    }
                });
            },
            minWidth: 100
        }, {
            type: 'actions',
            field: 'actions',
            headerName: 'Action',
            minWidth: 80,
            renderCell: function (params) {
                var _this = this;
                return /*#__PURE__*/ React.createElement(MoreIconSvg, {
                    color: "secondary.600",
                    onClick: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        Component: ActionMenuList,
                                        containerProps: {
                                            anchorEl: e === null || e === void 0 ? void 0 : e.target,
                                            anchorOrigin: {
                                                vertical: 'center',
                                                horizontal: 'right'
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'right'
                                            }
                                        },
                                        componentProps: {
                                            items: [{
                                                    id: 'viewInvoice',
                                                    children: ["View Invoice"]
                                                }, {
                                                    id: 'ReceivePayment',
                                                    children: ["Receive Payment"]
                                                }, {
                                                    id: 'CancleInvoice',
                                                    children: ["Cancle Invoice"]
                                                }, {
                                                    id: 'ShareInvoice',
                                                    children: ["Share Invoice"]
                                                }, {
                                                    id: 'PrintInvoice',
                                                    children: ["Print Invoice"]
                                                }]
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    if (!((res === null || res === void 0 ? void 0 : res.payload) === "viewInvoice")) return [3 /*break*/, 3];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: ViewInvoice,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        width: '80%'
                                                    }
                                                },
                                                anchor: 'right'
                                            },
                                            componentProps: {
                                                data: params === null || params === void 0 ? void 0 : params.row
                                            }
                                        }))];
                                case 2:
                                    _a.sent();
                                    _a.label = 3;
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
        }];
    var handleSurfaceResponse = function (cardData, response) {
        if (response !== null && response !== void 0 && response.payload) {
            dispatch(showSurface({
                type: 'Drawer',
                Component: ViewInvoice,
                containerProps: {
                    PaperProps: {
                        sx: {
                            borderRadius: '8px 8px 0 0'
                        }
                    },
                    anchor: 'bottom'
                },
                componentProps: {
                    data: cardData
                }
            }));
        }
    };
    return isMobile ? /*#__PURE__*/ React.createElement(Box, {
        py: 2
    }, /*#__PURE__*/ React.createElement(CardView, {
        isReadyForInvoiceTitle: true,
        isGrandTotalButton: false,
        isMenuIcon: true,
        isExpandButton: true,
        pagingApiCall: jciFilterPagingAPI,
        pagingKey: "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "Invoice"),
        pagingRequest: {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
            InvoiceTypeName: "JobCardInvoice",
            PagingFor: "Invoice"
        },
        pageSize: 20,
        onActionResponse: handleSurfaceResponse,
        cardMapper: function (data) {
            var _data$InvoiceDate;
            return {
                id: "card-".concat(data === null || data === void 0 ? void 0 : data.id),
                docNo: data !== null && data !== void 0 && data.RegistrationNo ? data === null || data === void 0 ? void 0 : data.RegistrationNo : '-',
                title: data !== null && data !== void 0 && data.ProductName ? data === null || data === void 0 ? void 0 : data.ProductName : '-',
                statusName: data !== null && data !== void 0 && data.StatusName ? data === null || data === void 0 ? void 0 : data.StatusName : '-',
                details: [{
                        label: "Job Card No",
                        value: data === null || data === void 0 ? void 0 : data.JobCardNo
                    }, {
                        label: "Customer",
                        value: data === null || data === void 0 ? void 0 : data.CustomerName
                    }, {
                        label: "Service Type",
                        value: data === null || data === void 0 ? void 0 : data.ServiceTypeName
                    }, {
                        label: "Invoice No:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceNumber
                    }, {
                        label: "Posting type:",
                        value: data === null || data === void 0 ? void 0 : data.ServiceAdvisor
                    }, {
                        label: "Invoice Date & time:",
                        value: dayjs((_data$InvoiceDate = data === null || data === void 0 ? void 0 : data.InvoiceDate) !== null && _data$InvoiceDate !== void 0 ? _data$InvoiceDate : '').format('DD MMM, YYYY - hh:mm a')
                    }, {
                        label: "Total amount:",
                        value: data === null || data === void 0 ? void 0 : data.InvoiceAmount
                    }, {
                        label: "Payment status:",
                        value: data === null || data === void 0 ? void 0 : data.PaymentStatus
                    }]
            };
        },
        menuIcons: function () { return null; },
        actionsMenu: storedMenuFeatures
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        getPagingData: jciFilterPagingAPI,
        pagingAPIKey: "".concat(JobCardInvoicesKeys.JCIFilterPagingKey, "Invoice"),
        pagingAPIRequest: _objectSpread(_objectSpread({}, !((value === null || value === void 0 ? void 0 : value.IdentityId) === 'all') && {
            IdentityId: value.IdentityId
        }), {}, {
            OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
            ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
            InvoiceTypeName: "JobCardInvoice",
            PagingFor: "Invoice"
        }),
        dataGridProps: {
            density: 'compact',
            initialState: {
                pinnedColumns: {
                    right: ['actions']
                }
            },
            disableColumnMenu: false
        },
        columns: pagingColumns
    })));
};
